import { ContentAuthor } from '../types';
import { Author as Trey } from './trey';
import { Author as Gibber } from './gibber';

export const authors: { [key: string]: ContentAuthor } = {
  trey: Trey,
  gibber: Gibber,
};
